<script>
  /**
   * @type {String} -  Export a variable to control the loading screen massage
   */
  export let msg = "loading"
</script>

<div class="fixed inset-0 -top-3 z-30 flex select-none flex-col items-center justify-center gap-3 rounded-md bg-white/50 backdrop-blur-md dark:bg-black/90">
  <div class="h-20 w-20 animate-spin rounded-full border-[3px] border-slate-300 border-r-blue-500" />
  <div class="flex items-center gap-3 text-gray-500 dark:text-white">
    <span>{msg}</span>
    <svg width="20" height="7" stroke="#707175" fill="#707175" viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg">
      <circle class="circle" cx="15" cy="15" r="15" />
      <circle class="circle1" cx="60" cy="15" r="9" fill-opacity="0.9" />
      <circle class="circle2" cx="105" cy="15" r="15" />
    </svg>
  </div>
</div>
